// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KTWg","largestCol":"styles_largestCol__2fxzS","smallestCol":"styles_smallestCol__3ybTV"};